import React from "react"
import { Input, Dropdown } from "semantic-ui-react"
import { Link } from "react-router-dom"

class EditableAccountName extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      newAccountName: props.name,
      isEdit: false,
      loading: false,
      oldAccountName: props.name
    }
  }
  onInputChange = ({ target: { value } }) => {
    this.setState({ newAccountName: value })
  }

  onSubmit = async submitFunction => {
    this.setState({ loading: true })
    if (this.state.newAccountName) {
      if (this.state.newAccountName !== this.state.oldAccountName) {
        await submitFunction(this.state.newAccountName)
      }
    }
    this.setState((prevState, props) => ({
      isEdit: false,
      newAccountName: prevState.newAccountName || props.name,
      loading: false,
      oldAccountName: prevState.newAccountName || props.name
    }))
  }
  render = () => (
    <div>
      <span>
        {this.props.confirm ? "Confirm " : "Edit "}
        {this.state.isEdit ? (
          <form
            style={{ display: "inline" }}
            onSubmit={e => {
              e.preventDefault()
              this.onSubmit(this.props.submit)
            }}
          >
            <Input
              loading={this.state.loading}
              size="mini"
              placeholder="Account Nickname"
              value={this.state.newAccountName}
              onChange={this.onInputChange}
              onBlur={() => this.onSubmit(this.props.submit)}
              autoFocus
            />
          </form>
        ) : (
          this.state.newAccountName
        )}{" "}
        Account
      </span>
      {this.state.isEdit ? null : (
        <span
          style={{
            fontWeight: "normal",
            color: "#00adef",
            paddingLeft: "0.2em",
            fontSize: ".9em",
            cursor: "pointer"
          }}
        >
          <Dropdown icon="pencil">
            <Dropdown.Menu>
              <Dropdown.Item
                onClick={() => this.setState({ isEdit: true })}
                content="Rename Account"
              />
              <Dropdown.Item
                as={Link}
                to={this.props.changeTypeLink}
                content="Change Account Type"
              />
            </Dropdown.Menu>
          </Dropdown>
        </span>
      )}
    </div>
  )
}

export default EditableAccountName
